<template>
  <div style="height: calc(100vh - 135px);overflow: auto;padding-right:3px">
    <div class="page_header" style="">
      <div  style="flex: 1;">
        <span class="page_title">{{$t('statistics.停车统计')}}</span>
        <el-tooltip class="item" effect="light" :content="$t('statistics.停车统计备注')" placement="top-start" v-show="!noteShow">
          <span
            style="font-size: 12px; color: #ff8c00; margin-left: 16px"
          >
            <i
              class="iconfont icon-icon_prompt2"
              style="font-size: 16px; margin-right: 4px"
            ></i>
          </span>
        </el-tooltip>
        <span class="remark" style="font-size: 12px;color: rgb(255, 140, 0);font-weight: 500; margin-left: 16px" v-show="noteShow"> 
          <i class="iconfont icon-icon_prompt2" style="font-size: 16px; margin-right: 4px"></i> 
          {{$t('statistics.停车统计备注')}}</span>
      </div>

      <quickQuery @handleQuery="handleQuery" @quickQuery="quickQuery" @download="download" :downloading="downloading" style="text-align: right"/>
    </div>
    <div><el-divider></el-divider></div>
    <div class="page_container">
      <el-table :size="size" border :data="listData" v-loading="loading">
        <el-table-column align="center" prop="CarNo" :label="$t('statistics.车辆')" min-width=""></el-table-column>
        <el-table-column align="center" prop="StartTime" :label="$t('statistics.开始运行时间')" min-width=""></el-table-column>
        <el-table-column align="center" prop="EndTime" :label="$t('statistics.结束运行时间')" min-width=""></el-table-column>
        <el-table-column align="center" prop="RunDuration" :label="$t('statistics.运行时长')" min-width=""></el-table-column>
        <el-table-column align="center" prop="IdleDuration" :label="$t('statistics.怠速时长')" min-width=""></el-table-column>
        <el-table-column align="center" prop="AirDuration" :label="$t('statistics.空调运行时长')" min-width=""></el-table-column>
        <el-table-column align="center" prop="ElecConsume" :label="$t('statistics.电耗')+'(kwh)'" min-width=""></el-table-column>
        <el-table-column align="center" prop="BeginSOC" :label="$t('statistics.开始电量')+'(%)'" min-width=""></el-table-column>
        <el-table-column align="center" prop="EndSOC" :label="$t('statistics.结束电量')+'(%)'" min-width=""></el-table-column>
      </el-table>
    </div>
    <div style="text-align: right ;margin-top:8px" class="pagination" v-show="total>0" >  <!--  -->
        <el-pagination
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import quickQuery from '../components/generalOrQuickQuery.vue'
import { mapState } from 'vuex';
import settings from "@/settings";
export default {
  name: "parkingStatistics",
  components:{quickQuery},
  data(){
    return{
      listData:[],
      loading:false,
      vehicles:"",
      beginDate:"",
      endDate:"",
      currentPage:1,
      pageSize:10,
      total:0,
      noteShow: false,
      screenWidth: undefined,
      downloading:false,
    }
  },
  mounted(){
     const currentPath = this.$route.path
    // 从全局变量中取出对应路由的开始时间
    const startTime = settings.routeStartTime[currentPath]
    if (startTime) {
      // 计算耗时（mounted时组件已挂载到DOM，UI基础展示完成）
      const renderTime = Date.now() - startTime
      console.log(`路由 ${currentPath} 渲染耗时：${renderTime}`)
      // 可选：上报到后端或日志系统
      // reportRenderTime(currentPath, renderTime)

      // 清除已计算的开始时间，避免重复计算
      delete settings.routeStartTime[currentPath]
    }


    this.screenWidth = document.body.clientWidth;
    const that = this;
    window.onresize = () =>
      (() => {
        window.screenWidth = document.body.clientWidth;
        that.screenWidth = window.screenWidth;
      })();
  },
  computed:{
    size() {
        return this.$store.getters.size
    },
    ...mapState({
        selectedVehicles: state => state.app.vehicles.selectedVehicles,
    }),
  },
  watch: {
    screenWidth(val) {
      // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
      if (!this.timer) {
        // 一旦监听到的screenWidth值改变，就将其重新赋给data里的screenWidth
        this.screenWidth = val;
        this.timer = true;
        const that = this;
        setTimeout(function () {
          if (that.screenWidth >= 1640) {
            that.noteShow = true;
          } else that.noteShow = false;
          that.timer = false;
        }, 10);
      }
      deep: true;
    },
  },
  methods:{
    handleCurrentChange(val) {
      // console.log(val);
      this.currentPage = val;
      this.getList();
    },
    handleQuery(val){
      // console.log(val);
      if(val.beginDate == "") {
        this.$message.warning(this.$t("vehicleInfo.请选择日期"));
        return;
      }
      this.beginDate = val.beginDate + " 00:00:00";
      this.endDate = val.endDate + " 23:59:59";
      this.vehicles = this.getSelectedVehicles();
      this.currentPage = 1;
      this.getList();
    },
    getSelectedVehicles(){
      this.vehicles = "";
      for(let k = 0; k < this.selectedVehicles.length; k++){
        if(this.selectedVehicles[k].treeLevel == 5){
          this.vehicles = this.vehicles + this.selectedVehicles[k].nodeValue + ",";
        }
      }
      return this.vehicles.substring(0,this.vehicles.length-1);
    },
    quickQuery(val){
      // console.log(val);
      this.beginDate = val.beginDate + " 00:00:00";
      this.endDate = val.endDate + " 23:59:59";
      this.vehicles = this.getSelectedVehicles();
      this.currentPage = 1;
      this.getList();
    },
    download(){
      this.vehicles = this.getSelectedVehicles();
      var that = this;
      that.downloading = true;
      this.$api.queryParkingRecord({
        vehicles: this.vehicles,
        BeginDate: this.beginDate,// "2025-08-10 00:00:00",
        EndDate: this.endDate,// "2025-08-10 23:59:59",
        // pageNo: this.currentPage,
        // pageSize: 10,
        Language: this.$store.getters.LanguageId,
        IsExport: 1, //1为下载 0 为查询
      },"blob")
      .then((res)=>{
        let blob = new Blob([res], {
            type: "application/vnd.ms-excel;charset=utf-8",
          }); // 重点代码
          let a = document.createElement("a");
          a.href = window.URL.createObjectURL(blob);
          a.setAttribute(
            "download",
            that.$t("statistics.停车统计")+that.$t("public.download") + `_${new Date().getTime()}.xlsx`
          ); // 表名，自定义
          a.click(); // 执行下载
          window.URL.revokeObjectURL(blob); // 释放ur
          that.downloading = false;
      })
      .catch((e)=>{
        that.downloading = false;
      })
    },
    getList(){
      this.loading = true;
      this.$api.queryParkingRecord({
        vehicles: this.vehicles,
        BeginDate: this.beginDate,// "2025-08-10 00:00:00",
        EndDate: this.endDate,// "2025-08-10 23:59:59",
        pageNo: this.currentPage,
        pageSize: 10,
        // Language: this.$store.getters.LanguageId,
        IsExport: 0, //1为下载 0 为查询
      })
      .then((res)=>{
        this.listData = res.data;
        this.total = res.recordsTotal;
        this.loading = false;
      })
      .catch((e)=>{
        this.listData = [];
        this.total = 0;
        this.loading = false;
      })
    },
  },

}
</script>
<style  lang="scss" scoped>
.pagination  {
  ::v-deep .el-pagination button:disabled,.el-pager li,.el-pagination .btn-prev, .el-pagination .btn-next{
    background-color: transparent !important;
  }

}
</style>